import authorizationActions from './authorization-actions'

export const authorizationReducer = (
  state = {
    magicLinkError: '',
    magicLinkSending: false,
    verifyError: '',
    verifyInProgress: false,
  },
  action
) => {
  switch (action.type) {
    case authorizationActions.actionTypes.REQUEST_MAGIC_LINK:
      return {
        ...state,
        magicLinkSending: true,
      }
    case authorizationActions.actionTypes.REQUEST_MAGIC_LINK_FAILED:
      return {
        ...state,
        magicLinkError: action.payload.message,
        magicLinkSending: false,
      }
    case authorizationActions.actionTypes.REQUEST_MAGIC_LINK_SUCCEEDED:
      return {
        ...state,
        magicLinkError: '',
        magicLinkSending: false,
      }
    case authorizationActions.actionTypes.VERIFY_MAGIC_LINK:
      return {
        ...state,
        verifyError: '',
        verifyInProgress: true,
      }
    case authorizationActions.actionTypes.VERIFY_MAGIC_LINK_FAILED:
      return {
        ...state,
        verifyError: action.payload.message,
        verifyInProgress: false,
      }
    case authorizationActions.actionTypes.VERIFY_MAGIC_LINK_SUCCEEDED:
      return {
        ...state,
        verifyError: '',
        verifyInProgress: false,
      }
    case authorizationActions.actionTypes.RESET_LOGIN_ERRORS:
      return {
        ...state,
        magicLinkError: '',
        verifyError: '',
      }
    default:
      return state
  }
}
